import React from 'react'
import PropTypes from 'prop-types'

import { GlgTooltip } from 'Shared/components'

const InfoTooltipIcon = ({ tooltip }) => {
  return (<GlgTooltip tooltip={tooltip}>
    <i className='gga-info-circle'/>
  </GlgTooltip>)
}

InfoTooltipIcon.propTypes = {
  tooltip: PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]).isRequired,
}

export default InfoTooltipIcon
